enum CreateFeeType {
    TemplatedFee = "TEMPLATED_FEE",
    ManualFee = "MANUAL_FEE"
}
export default CreateFeeType
